<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-file-pdf-box</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.pdf') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 15px 0 15px;" />
      <span style="color:rgba(0, 0, 0, 0.54);">{{$t('menuType.pdf')}}</span>     
    </v-toolbar>
    <v-file-input
      v-if="content.IsNew"
      v-model="file"
      display-size
      @change="handleChangePDFFile"
      style="margin-left: 15px"
      accept=".pdf" 
    />
    <v-text-field
      v-else
      v-model="content.URL"
      hideDetails
      :disabled="true"
      style="margin-left: 15px"
      @input="handleChangeIsModified"
    />
    <v-checkbox
      v-model="content.DownloadPdf"
      :value="content.DownloadPdf"
      @change="handleChangeIsModified"
      :label="$t('common.download')"
    />
  </div>
</template>

<script>
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      file: null
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
      uploadPDF (file) {
        const body = {
          newPdf: file,
          EnterpriseID: this.enterpriseID
        }
        api.addItem('utils/pdf', body)
          .then(response => {
            if (response.status === 200) {
              this.handleChangeIsModified()
              // this.file = response.data
              this.content.URL = response.data
              this.loading = false
            }
          })
          .catch(error => {
            console.log('error', error)
            this.loading = false
          })
      },
      handleChangePDFFile () {
        const that = this
        this.loading = true
        const reader = new FileReader()
        reader.readAsDataURL(this.file)
        reader.onload = function () {
          that.uploadPDF(reader.result)
        }
        reader.onerror = function (error) {
          console.log('Error: ', error)
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
</style>

